import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationTestSampleError = () => {
  const { accessToken } = useAuthentication();

  return useMutation(async () => {
    const response = await fetch(
      `${import.meta.env.VITE_API_HOST}/sample-error`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: accessToken ?? "",
        },
      },
    );

    if (!response.ok) {
      throw new Error("API threw sample error");
    }

    return null;
  });
};
